import { test } from "../../../views/partials/titleTemplates/DesignArch/DesignArch";

export function invitation_template_design(){
    test();
}